import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { Reveal, Section } from '@/components/ui'
import { WorkTogetherCta } from '@/features/cta'
import { DomainExpertise } from '@/features/services'

/** What I offer, organised by the same three domains as everything else. */
export const ServicesPage = () => {
  const { site } = useContent()
  useDocumentMeta({
    title: `Expertise - ${site.name}`,
    description:
      'UI/UX and brand design, full-stack and mobile development, cloud infrastructure and networking.',
  })

  return (
    <>
      <Section spacious>
        <h1 className="visually-hidden">Expertise</h1>
        <DomainExpertise />
      </Section>

      <Reveal>
        <WorkTogetherCta />
      </Reveal>
    </>
  )
}
